import store from '@/store'
import { CLEAR, INIT, SET_LOADING_STATUS, SET_STATUS_MESSAGE, SET_TOTAL_COUNT, SPLICE } from './mutation-types'

const state = {
  pollingEvents: [],
  totalCount: 0,
  status: {
    loading: false,
    message: 'Loading'
  }
}

const getters = {
  getLoadingStatus: (state) => {
    return state.status.loading
  },
  getLoadingText: (state) => {
    return state.status.message
  },
  getAllPollingEvents: (state) => {
    return state.pollingEvents
  },
  getTotalCount: (state) => {
    return state.totalCount
  }
}

const actions = {
  setLoadingStatus ({ commit }, { val }) {
    commit(SET_LOADING_STATUS, { val })
  },
  setStatusMessage ({ commit }, { message }) {
    commit(SET_STATUS_MESSAGE, { message })
  },
  async init ({ commit }, { newPollingEvents, totalCount, isFullArraySize }) {
    commit(SET_LOADING_STATUS, { val: false })
    try {
      commit(SET_TOTAL_COUNT, { val: totalCount })
      commit(INIT, { newPollingEvents, totalCount: isFullArraySize ? totalCount : newPollingEvents.length })
    } catch (error) {
      store.dispatch('alert/error', error.message)
    }
  },
  async next ({ commit }, { newPollingEvents, startIndex }) {
    commit(SET_LOADING_STATUS, { val: false })
    try {
      commit(SPLICE, { newPollingEvents, startIndex })
    } catch (error) {
      store.dispatch('alert/error', error.message)
    }
  },
  async clear ({ commit }) {
    commit(CLEAR)
  },
  setTotalCount ({ commit }, { val }) {
    commit(SET_TOTAL_COUNT, { val })
  }
}

const mutations = {
  [SET_LOADING_STATUS] (state, { val }) {
    state.status.loading = val
  },
  [SET_STATUS_MESSAGE] (state, { message }) {
    state.status.message = message
  },
  [INIT] (state, { newPollingEvents, totalCount }) {
    if (totalCount === 0) return
    const objs = JSON.parse(JSON.stringify(newPollingEvents))
    state.pollingEvents = new Array(totalCount)
    const mappedObjs = objs.map(obj => {
      obj.listChoicesRoute = { name: 'pollingEventChoices', params: { pollingEventId: obj.id } }
      return obj
    })
    state.pollingEvents.splice(0, objs.length, ...mappedObjs)
  },
  [SPLICE] (state, { newPollingEvents, startIndex }) {
    const objs = JSON.parse(JSON.stringify(newPollingEvents))
    const mappedObjs = objs.map(obj => {
      obj.listChoicesRoute = { name: 'pollingEventChoices', params: { pollingEventId: obj.id } }
      return obj
    })
    state.pollingEvents.splice(startIndex, objs.length, ...mappedObjs)
  },
  [SET_TOTAL_COUNT] (state, { val }) {
    state.totalCount = val
  },
  [CLEAR] (state) {
    state.pollingEvents = []
    state.status = {
      loading: false,
      message: 'Loading Polling Events. Please wait...'
    }
    state.totalCount = 0
  }
}

export const pollingEventMapActions = {
  initPollingEvents: 'polling/init',
  appendPollingEvents: 'polling/next',
  clearPollingEvents: 'polling/clear'
}

export const polling = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
